<template>
    <div class="calendarDay">
        <template v-for="n in 24">
            <div class="hour" :ref="n" :key="`h${n}`"><span v-if="showTimes">{{n -
            1}}:00</span></div>
            <div class="halfhour" :key="`hh${n}`"></div>
        </template>
        <calendar-day-event v-for="(e, ind) in todaysNotAllDayEvents" :key="ind" :event="e" :style="style[e.calid]"
                @click="selectEvent(e)">
        </calendar-day-event>
    </div>
</template>

<script>
// import { DateTime } from 'luxon';
import CalendarDayEvent from '@/components/calendarDayEvent';

export default {
  name: 'calendarDayView',
  components: { CalendarDayEvent },
  data: function() {
    return {
    };
  },
  props: {
    events: Array,
    date: Object,
    showTimes: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs['7'][0].scrollIntoView();
    });
  },
  methods: {
    selectEvent(event) {
      console.log('cal event click', event);
      if (event.recurrence) {
        this.$router.push(
          { name: 'calendarEditRecurEvent',
            params: Object.assign({}, this.$route.params, { eventId: event.id, recurId: event.recurId }) });
      } else {
        this.$router.push(
          { name: 'calendarEvent', params: Object.assign({}, this.$route.params, { eventId: event.id }) });
      }
    }
  },
  computed: {
    dateTitle() {
      return this.date.toLocaleString({ weekday: 'short', day: 'numeric' });
    },
    todaysAllDayEvents() {
      return [];
    },
    todaysNotAllDayEvents() {
      return this.todaysEvents.filter(e => !e.displayAllDay);
    },
    todaysEvents() {
      const dayStart = this.date;
      const dayEnd = this.date.endOf('day');
      let events = this.events.filter(e => {
        return (e.startDateTime <= dayEnd) && (e.endDateTime >= dayStart) && (!e.allday);
      })
        .sort((a, b) => {
          if (a.startDateTime < b.startDateTime) {
            return -1;
          } else if (a.startDateTime > b.startDateTime) {
            return 1;
          } else {
            return 0;
          }
        });

      let minuteEvents = [];
      for (let m = 0; m <= 60 * 24; ++m) {
        minuteEvents.push({ max: 0 });
      }

      events.forEach(e => {
        if ((e.startDateTime < dayStart) || (e.endDateTime > dayEnd) || (e.allday)) {
          e.displayAllDay = true;
        } else {
          e.displayAllDay = false;
          e.startMinute = e.startDateTime.hour * 60 + e.startDateTime.minute;
          e.endMinute = e.endDateTime.hour * 60 + e.endDateTime.minute;
          let min = 0;
          let clash = false;
          do {
            clash = false;
            for (let m = e.startMinute; m <= e.endMinute; ++m) {
              if (minuteEvents[m][min]) {
                clash = true;
                break;
              }
            }
            if (clash) {
              min++;
            }
          }
          while (clash);
          for (let m = e.startMinute; m <= e.endMinute; ++m) {
            minuteEvents[m][min] = true;
            minuteEvents[m].max = Math.max(minuteEvents[m].max, min + 1);
          }
          e.displayColumn = min;
        }
      });

      events.forEach(e => {
        if (!e.displayAllDay) {
          let max = 0;
          for (let m = e.startMinute; m <= e.endMinute; ++m) {
            max = Math.max(minuteEvents[m].max, max);
          }
          e.displayColumnCount = max;
        }
      });

      return events;
    },
    style() {
      return this.$store.getters.calendarEventStyles;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .calendarDay {
        position: relative;
        .hour, .halfhour {
            height: $calendar-day-row;
            overflow: hidden;
            &.hour {
                border-top: 1px solid $calendar-hour-border;
                color: $gray-300;
            }
            &.halfhour {
                border-top: 1px solid $calendar-halfhour-border;
            }
        }
    }

</style>
